import { useTranslate } from '@tolgee/react';
import ContentLoader from 'react-content-loader';

const ConversationListLoader = (props) => {
  const { t } = useTranslate();
  return (
    <div>
      {[1, 2, 3].map((i) => (
        <ContentLoader
          key={i}
          speed={4}
          width={300}
          height={150}
          viewBox="0 0 300 150"
          backgroundColor="#f6f5f4"
          foregroundColor="#deddda"
          title={t('communication.skeleton.title')}
          {...props}
        >
          <rect x="20" y="75" rx="0" ry="0" width="52" height="45" />
          <rect x="96" y="70" rx="0" ry="0" width="180" height="10" />
          <rect x="96" y="90" rx="0" ry="0" width="180" height="10" />
          <rect x="96" y="110" rx="0" ry="0" width="180" height="10" />
          <rect x="276" y="40" rx="0" ry="0" width="15" height="15" />
          <circle cx="263" cy="46" r="6" />
          <circle cx="22" cy="41" r="9" />
        </ContentLoader>
      ))}
    </div>
  );
};

export default ConversationListLoader;
